import React, {memo} from 'react';
import Facebook from './Facebook';
import Flickr from './Flickr';
import Google from './Google';
import Instagram from './Instagram';
import Generic from './Generic';
import {PrivacyPolicyButtonProps} from './PrivacyPolicyButton';

const ButtonFactory = ({
  code,
  onClick,
  pending,
  privacyPolicyUrl,
}: {
  code: string;
  onClick: (event: React.MouseEvent) => void;
  pending: boolean;
} & PrivacyPolicyButtonProps) => {
  const commonProps = {
    onClick: onClick,
    pending: pending,
    privacyPolicyUrl: privacyPolicyUrl,
  };

  switch (code) {
    case '%GOOGLEPHOTOS%':
      return <Google {...commonProps} />;
    case '%FACEBOOK%':
      return <Facebook {...commonProps} />;
    case '%INSTAGRAM%':
      return <Instagram {...commonProps} />;
    case '%FLICKR%':
      return <Flickr {...commonProps} />;
    default:
      return <Generic {...commonProps} />;
  }
};

export default memo(ButtonFactory);
